// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2dV-9","label":"Category_label__QqWcP","content":"Category_content__3OTaJ","header":"Category_header__1DRKg","location":"Category_location__c0FT4"};